import { businessCategoryEnum } from '../enums/businessCategoryEnum';

const kycDocumentsMap = new Map();

const soleProprietorDocs = [
  'cac-certificate-of-registeration',
  'cac-bn-1-form',
  'proof-of-address',
  'patnership-resolutions',
  'partnership-deed-or-agreement',
];

kycDocumentsMap.set(businessCategoryEnum.SOLE_PROPRIETOR, soleProprietorDocs);

const privateLimitedDocs = [
  'cac-certificate-of-incoporation',
  'ctc-memorandum-and-articles-of-association',
  'ctc-of-form-cac-7-directors-particulars',
  'ctc-of-form-cac2-shareholders-particulars',
  'scuml-certificate',
  'proof-of-business-address',
  'operating-license',
];

kycDocumentsMap.set(businessCategoryEnum.PRIVATE_LIMITED_LIABILITY_COMPANY, privateLimitedDocs);

const publicLimitedDocs = privateLimitedDocs.filter((x) => x !== 'ctc-of-form-cac2-shareholders-particulars');

kycDocumentsMap.set(businessCategoryEnum.PUBLIC_LIMITED_LIABILITY_COMPANY, publicLimitedDocs);

const ngoDocuments = [
  'cac-certificate-of-incoporation',
  'ctc-of-the-form-cac-or-it-1',
  'signed-board-resolution-or-mom',
  'proof-of-business-address',
  'scuml-certificate',
];

kycDocumentsMap.set(businessCategoryEnum.NON_GOVERNMENTAL_ORGANIZATION, ngoDocuments);

const governmentDocs = [
  'signed-approval-or-mandate-letter',
  'additional-supporting-documents',
];

kycDocumentsMap.set(businessCategoryEnum.GOVERNMENT, governmentDocs);

export default kycDocumentsMap;
